import React, { Suspense } from "react";

import { Switch, Route } from "react-router-dom";

import { HelloWorld } from "../HelloWorld";
import { ROUTE_LOGIN, LOGIN_WITH_ACCU, HELLO_WORLD } from "../../routes";
import LandingLoginContainer from "../../container/LandingLoginContainer";

export const Application = () => {
    return (
        <React.Fragment>
            <Switch>
                <Route
                    exact
                    path={HELLO_WORLD}
                    render={() => (
                        <Suspense>
                            <HelloWorld />
                        </Suspense>
                    )}
                />

                <Route
                    exact
                    path={[ROUTE_LOGIN, LOGIN_WITH_ACCU]}
                    render={() => (
                        <Suspense>
                            <LandingLoginContainer />
                        </Suspense>
                    )}
                />
            </Switch>
        </React.Fragment>
    );
};
